import React, { Fragment } from "react";
import styles from "./styles.css";
import { Label } from "@cars24/turbo-web/lib/label";
import { NUMBER } from "../../../constants/app-constants";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import AutoScroll from "../../shared/auto-scroll";
import PropTypes from "prop-types";

const HighlightsStrip = ({ content }) => {
    const { tokens } = useTokens();
    return (
        <div styleName={"styles.highlightsStripContainer"}>
            <AutoScroll speed={NUMBER.TWENTY} overflow="hidden" gap="32px">
                {content?.map((highlight, index) => (
                    <Fragment key={index}>
                        <Label
                            level={NUMBER.TWO}
                            fontWeight="semibold"
                            color={tokens.text_default_text_primary}
                        >
                            {highlight}
                        </Label>
                        <Label
                            level={NUMBER.TWO}
                            fontWeight="semibold"
                            color={tokens.text_default_text_primary}
                        >
              ✦
                        </Label>
                    </Fragment>
                ))}
            </AutoScroll>
        </div>
    );
};

HighlightsStrip.propTypes = {
    content: PropTypes.array
};

export default HighlightsStrip;
